(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["activity-header"] && !Shopify.designMode) return;
  try {
    
  var ActivityHeader = class extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const button = this.querySelector('.header-button');
      if (button) {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          window._klOnsite = window._klOnsite || [];
          window._klOnsite.push(['openForm', 'UkPCfK']);
        });
      }
    }
  };
  if (!window.customElements.get('activity-header')) {
    window.customElements.define('activity-header', ActivityHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["activity-main-slide"] && !Shopify.designMode) return;
  try {
    
  var PromptMainSlider = class extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
    }

    isMobile() {
      const mediaQuery = '(max-width: 768px)';
      const mql = window.matchMedia(mediaQuery);

      if (mql.matches) {
        return true;
      } else {
        return false;
      }
    }

    initSwiper() {
      let id = this.getAttribute('section-id');
      let className = '.pc-swiper-' + id;
      let paginationClassname = '.pc-pagination-' + id;
      if (this.isMobile()) {
        className = '.mobile-swiper-' + id;
        paginationClassname = '.mobile-pagination-' + id;
      }
      const speed = this.dataset.speed
      this.swiper = new Swiper(className, {
        loop: true,
        autoplay:
         {
          delay: speed * 1000,
          stopOnLastSlide: false,
          disableOnInteraction: true,
        },
        spaceBetween: 20,
        slidesPerView: 'auto',
        pagination: {
          el: paginationClassname, // 指定分页器容器的选择器
          clickable: true,        // 允许点击小圆点切换幻灯片
        },
        on: {
          slideChangeTransitionEnd: function () {
            // 获取当前激活的slide
            const activeSlide = this.slides[this.activeIndex];
            // 获取按钮文本
            const btnText = activeSlide.getAttribute('data-btntext');
            // 获取对应的button元素并更新内容
            const button = activeSlide.closest('.swiper').querySelector('.prompt-button span');
            if (button && btnText) {
              button.textContent = btnText;
            }
          }
        }
      });
    }

    initBuyButton() {
      const buyButtons = this.querySelectorAll('button.prompt-button');
      const _this = this;
      for(const buyButton of buyButtons){
        buyButton.addEventListener('click', function () {
          const curr = _this.swiper.slides[_this.swiper.activeIndex];
          const link = curr.getAttribute('link');
          window.location.href = link;
        });
      }
    }

    connectedCallback() {
      this.initSwiper();
      this.initBuyButton();
    }
  };
  if (!window.customElements.get('activity-main-slide')) {
    window.customElements.define('activity-main-slide', PromptMainSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["activity-menu"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const menuButtons = document.querySelectorAll('.lj-menu .menu-button');
    menuButtons.forEach((button) => {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', 'UkPCfK']);
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
